import type { LanguageCode } from "common/types/languageCode";

export type Translation = Partial<Record<LanguageCode, TranslationItem>>;
type TranslationItem = { text: string; type: TranslationType };

export enum TranslationType {
  AUTOMATED = "automated",
  MANUAL = "manual",
}
